export const FileObjectType = {
  assessment: 1,
  control: 2,
  recommendation: 3,
};
